<!-- 蛋卷出行用户隐私协议 -->
<template>
  <div class="agreement-datail">
    <div class="agreement-datail-content" v-html="agreementContent"></div>
  </div>
</template>

<script>
  export default {
    name: "privacyAgreementC",
    data(){
      return {
        agreementContent: '',
      }
    },
    computed: {
      companyName(){
        // 桂林，北海，贵港，防城港，梧州
        const cityObj = {
          'guilin':'广西蛋卷科技有限公司桂林市分公司', 
          'beihai':'广西蛋卷科技有限公司北海市分公司', 
          'guigang':'广西蛋卷科技有限公司贵港市分公司', 
          'fangchenggang':'广西蛋卷科技有限公司防城港市分公司', 
          'wuzhou':'广西蛋卷科技有限公司梧州市分公司'
        }
        if(!this.$route.params.city){
          return '广西蛋卷科技有限公司'
        }
        if(!cityObj[this.$route.params.city]){
          return '广西蛋卷科技有限公司'
        } 
        return cityObj[this.$route.params.city]
      }
    },
    watch: {
      companyName: function(newVal, oldVal){
        this.initData()
      }
    },
    mounted() {
      this.initData()
    },
    methods: {
     
      async initData(){
        //内容在蛋卷出行后台管理系统中活动管理的富文本编辑而来
        this.agreementContent = `<p style=\"text-align: center;\"><span style=\"font-size: 18px;\"><strong>《${this.companyName}隐私政策》</strong></span></p>\n<p>## 一、引言</p>\n<p>${this.companyName}（以下简称&ldquo;我们&rdquo;&ldquo;本公司&rdquo;或&ldquo;公司&rdquo;）致力于保护用户的隐私和个人信息安全。本隐私政策适用于我们为第三方平台的乘客提供网约车服务的过程中所涉及的个人信息处理活动。</p>\n<p>&nbsp;</p>\n<p>## 二、定义</p>\n<ol>\n<li>&ldquo;个人信息&rdquo;：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</li>\n<li>&ldquo;第三方平台&rdquo;：指与我们合作，为乘客提供网约车服务入口的平台。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 三、我们收集的个人信息</p>\n<ol>\n<li>为了向您提供网约车服务，我们可能会收集以下个人信息：</li>\n</ol>\n<p>&nbsp;&nbsp;&nbsp; - 基本信息：电话号码。</p>\n<p>&nbsp;&nbsp;&nbsp; - <strong>位置信息</strong>：用于确定上车地点、行驶路线和到达目的地。</p>\n<p>&nbsp;&nbsp;&nbsp; - <strong>行程信息</strong>：包括出发地、目的地、行程时间、行程费用。</p>\n<p>&nbsp;&nbsp;&nbsp; - <strong>支付信息</strong>：如支付方式、支付金额（仅在涉及支付环节时收集）。</p>\n<p>&nbsp;&nbsp;&nbsp; - 设备信息：设备型号、操作系统，以确保服务的正常运行和安全性。</p>\n<ol start=\"2\">\n<li>我们可能会通过以下方式收集个人信息：</li>\n</ol>\n<p>&nbsp; &nbsp;&nbsp;- 您在第三方平台上提供的信息。</p>\n<p>&nbsp;&nbsp;&nbsp; - 在您使用我们的服务过程中自动收集。</p>\n<p>&nbsp;&nbsp;&nbsp; - 从合法的第三方来源获取，如支付服务提供商等。</p>\n<p>&nbsp;</p>\n<p>## 四、个人信息的使用目的</p>\n<ol>\n<li>提供网约车服务：包括匹配司机、规划路线、提供行程信息。</li>\n<li>客户服务：处理您的咨询、投诉和建议。</li>\n<li>安全保障：确保行程安全，预防和处理欺诈、违规等行为。</li>\n<li>改善服务：分析用户行为和需求，优化服务体验。</li>\n<li>法律合规：遵守适用的法律法规要求。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 五、个人信息的共享</p>\n<ol>\n<li>我们仅在以下情况下与第三方共享您的个人信息：</li>\n</ol>\n<p>&nbsp;&nbsp;&nbsp; - 与为我们提供服务的合作伙伴共享，如司机、地图服务提供商、支付服务提供商等，但这些合作伙伴仅能在为提供服务的目的下使用您的个人信息。</p>\n<p>&nbsp;&nbsp;&nbsp; - 应法律法规要求或政府部门的指令进行共享。</p>\n<ol start=\"2\">\n<li>我们会与第三方签订保密协议，要求其采取适当的安全措施保护您的个人信息。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 六、个人信息的存储</p>\n<ol>\n<li>我们将在合理必要的期限内存储您的个人信息，以实现上述使用目的。</li>\n<li>存储期限届满后，我们将采取合理的措施删除或匿名化处理您的个人信息。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 七、个人信息的安全</p>\n<ol>\n<li>我们采取一系列技术和管理措施来保护您的个人信息安全，包括加密、访问控制、安全审计等。</li>\n<li>尽管我们采取了上述措施，但请注意，没有任何一种安全措施是绝对完美的，您也应妥善保管自己的个人信息，避免泄露。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 八、您的权利</p>\n<ol>\n<li>您有权访问、更正、删除您的个人信息。</li>\n<li>您有权撤回对我们处理您个人信息的同意。</li>\n<li>您有权要求我们限制处理您的个人信息。</li>\n<li>您有权获取您的个人信息副本。</li>\n<li>您有权向有关监管部门投诉我们的个人信息处理活动。</li>\n</ol>\n<p>&nbsp;</p>\n<p>## 九、隐私政策的更新</p>\n<p>我们可能会不时更新本隐私政策。我们将在第三方平台上发布更新后的隐私政策，并在更新生效前通过适当的方式通知您。如果您继续使用我们的服务，即表示您同意更新后的隐私政策。</p>\n<p>&nbsp;</p>\n<p>## 十、联系方式</p>\n<p>如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式联系我们：</p>\n<p>[公司联系邮箱]：xaz@danjuantec.com</p>\n<p>[公司客服电话]：07715883092</p>\n<p>&nbsp;</p>`
      }
        
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep{
    .agreement-datail-content{
      img{
        display: block !important;
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
    
  .agreement-datail{
    
  }
</style>